import { proxy } from 'valtio';
import { EngagementTeamMember } from '@oldDashboard/legacyModels/engagementTeamMember.model';  

interface ITeamdata {
  teamData: EngagementTeamMember[];
}

class TeamDataStore {
  // Initial state setup
  state = proxy<ITeamdata>({
    teamData: []
  });

}

export const teamState = proxy(new TeamDataStore());